<template>
	<aside class="common-error-message">
		<div class="common-error-message__inner">
			<p class="common-error-message__icon">
				<svg width="48" height="46" viewBox="0 0 48 46">
					<rect width="48" height="46" fill="none"/>
					<path d="M157.547,128.869l-14.569-25.234a8.392,8.392,0,0,0-2.405-2.73,5.323,5.323,0,0,0-6.318,0,8.392,8.392,0,0,0-2.405,2.73l-14.57,25.234a8.053,8.053,0,0,0-1.186,3.993,5.462,5.462,0,0,0,.5,2.322,5.39,5.39,0,0,0,2.479,2.506,8.258,8.258,0,0,0,3.77.817h29.138a7.531,7.531,0,0,0,4.784-1.47,5.208,5.208,0,0,0,1.466-1.854,5.453,5.453,0,0,0,.5-2.322A8.046,8.046,0,0,0,157.547,128.869Zm-2.466,4.84a1.9,1.9,0,0,1-.911.883,4.833,4.833,0,0,1-2.188.437H122.844a4.134,4.134,0,0,1-2.606-.7,1.716,1.716,0,0,1-.493-.615,1.972,1.972,0,0,1-.173-.848,4.633,4.633,0,0,1,.719-2.253l14.57-25.234a4.978,4.978,0,0,1,1.387-1.619,1.859,1.859,0,0,1,2.332,0,4.977,4.977,0,0,1,1.387,1.619l14.569,25.234a4.635,4.635,0,0,1,.719,2.253A1.973,1.973,0,0,1,155.082,133.709Z" transform="translate(-113.094 -95.866)" fill="#fff" />
					<path d="M279.192,209.769a2.669,2.669,0,0,0-1.957.815,2.164,2.164,0,0,0-.814,1.63l.081.245,1.385,8.556.326,1.467a1.27,1.27,0,0,0,.326.489.88.88,0,0,0,.652.244.923.923,0,0,0,.61-.244,1.154,1.154,0,0,0,.367-.489l1.711-10.023v-.245a2.536,2.536,0,0,0-.733-1.711A3.029,3.029,0,0,0,279.192,209.769Z" transform="translate(-254.831 -193.026)" fill="#fff" />
					<path d="M280.435,331.351a2.412,2.412,0,0,0-1.875.815,2.444,2.444,0,0,0-.733,1.793,2.509,2.509,0,0,0,2.608,2.607,2.72,2.72,0,0,0,1.874-.733,2.534,2.534,0,0,0,.733-1.874,2.439,2.439,0,0,0-.733-1.793A2.581,2.581,0,0,0,280.435,331.351Z" transform="translate(-256.073 -300.511)" fill="#fff" />
				</svg>
			</p>
			<p class="common-error-message__text"><slot /></p>
		</div>
	</aside>
</template>

<script>
export default {
	name: 'CommonErrorMessage'
}
</script>

<style lang="scss">
// 変数定義SASS
@import "@/assets/sass/variable";

.common-error-message {
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: rgba($_black, .5);
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	opacity: 1;
	z-index: 9999;
	pointer-events: none;

	&__inner {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-family: $lp-family-primary;
		text-align: center;
		color: $text-seconday;
		font-size: $font-size-14;
	}

	&__icon {
		margin: $spacing-6 0 0;
	}

	&__text { margin: 0; }
}
</style>
